<div class="t-popup-body" style="overflow: auto;" [formGroup]="gfs.Form"  >
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>
    <div class="formHeader">
        <h2 style="align-self: center;">
            Recovery Form
        </h2>
        <span  class="icon-print" (click)="printForm()" style="margin-inline-end: 1.5em;" aria-label="Print" matTooltip="Print"><img src="../../../assets/icons/print.svg"></span>
    </div>
    <div class="m-box">
    <section class="w100" style="direction: rtl;justify-content: space-evenly;display: flex;">
        <span>זיהוי מטופל <input type="checkbox" formControlName="PatientIdentification"></span>
        <span> בדיקות לביצוע:</span>
        <span>קולונוסקופיה <input type="checkbox" formControlName="Colonoscopy"></span>
        <span>גסטרוסקופיה <input type="checkbox" formControlName="Gastroscopy"></span>
        <span>סיגמואידוסקופיה <input type="checkbox" formControlName="Sigmoidoscopy"></span>

    </section>
    <div style="display: flex; margin: 0 3.5em;">
        <div class="w40" style="display: flex; margin: 0.3em;">
            <span class="t-field t-field--number" style="direction: ltr;">
                <input class="t-field-text" type="time" id="CheckTime" formControlName="AdmissionTime" />
            </span>
            <span style="margin-left: 0.3em; align-self: center;">
                שעת קבלה
            </span>
        </div>
        <div class="w40" style="display: flex;margin-top: 0; margin: 0.3em;">
            <span class="t-field t-field--number" style="direction: rtl;">
                <input class="t-field-text" type="text" formControlName="AssignedDoctor" />
            </span>
            <span style="margin-left: 0.3em; align-self: center;">
                רופא
            </span>
        </div>
    </div>
</div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;justify-content: space-between;" >
        <h2>מדדים</h2>
        <form [formGroup]="gsf.measurements" style="display: flex">
            <div class="w20" style="display: flex;margin-top: 0; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">חום</span> 
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="number" min="0" id="Temp"
                        formControlName="Temp" />
                    <span class="t-field-desc">
                        *C
                    </span>
                </span>
            </div>
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">דופק</span> 
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="number" min="0" id="Pulse"
                        formControlName="Pulse" />
                    <span class="t-field-desc">
                        bpm
                    </span>
                </span>
            </div>                
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 5px;align-self: center;">לחץ דם</span>
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="number" min="0" formControlName="bpSystolic" style='width: 3em;text-align: center;text-align-last: center;'/>/<input class="t-field-text" type="number" min="0" formControlName="bpDyastolic" style='width: 3em;text-align: center;text-align-last: center;'>
                    <span class="t-field-desc" style="padding: 0.3em;">
                        mmHg
                    </span>
                </span>
            </div>
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">סיטורציה</span> 
                <span class="t-field t-field--number" style="direction: ltr;min-width: 6.31em;">
                    <input class="t-field-text" type="number" min="0" formControlName="Saturation" style='text-align: center;text-align-last: center;'/>
                    <span class="t-field-desc" style="padding: 0.3em;">
                        %
                    </span>
                </span>
            </div>
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">שעת הבדיקה</span> 
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="time" id="CheckTime"
                        formControlName="CheckTime" />
                </span>
            </div>
            <button class="btnAdd" (click)="gsf.saveNew()" [disabled]="gfs.isClosed">Add</button>
        </form>
        <section class="m-box padd" style="height: auto;" *ngIf="gsf.patMeasurements&&gsf.patMeasurements.length >0">
                            <table class="weightAss-table" style="width: 100%;">
                                <tr class="weightAss-thead">
                                    <td class="l-td-m">#</td>
                                    <td class="l-td-m">חום</td>
                                    <td class="l-td-m">דופק</td>
                                    <td class="l-td-m">לחץ דם</td>
                                    <td class="l-td-m">סיטורציה</td>
                                    <td class="l-td-m">שעת בדיקה</td>
                                    <td class="l-td-m"></td>
                                </tr>
                                <ng-container *ngIf="gsf.patMeasurements">
                                    <tr class="weightAss-tbody" *ngFor="let meas of gsf.patMeasurements; index as i">
                                        <td class="l-td-m">{{i+1}}</td>
                                        <td class="l-td-m">{{meas.Temp}}</td>
                                        <td class="l-td-m">{{meas.Pulse}}</td>
                                        <td class="l-td-m">{{meas.bpDyastolic}} / {{meas.bpSystolic}}</td>
                                        <td class="l-td-m">{{meas.Saturation}}</td>
                                        <td class="l-td-m">{{meas.CheckTime}}</td>
                                        <!-- <td class="l-td-m"><span class="linked-radios-duration"><img src="../../assets/icons/del.svg"
                                            matTooltip="Delete"
                                            (click)="medS.deleteMed(med.AutoIndex)"></span></td> -->
                                    </tr>
                                </ng-container>
                            </table>
                        </section>
    </div>
    <div style="display: flex;justify-content: space-between;">
        <p>Aldrete Score</p>
        <p>ניקוד אלדורייט</p>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;;">-
        <h2>תנועתיות</h2>
        <div style="z-index: 7;">
            <div  style="display: flex;z-index: 1000; justify-content: space-between">
                <div style="direction: ltr" class="w20 anatomy-item" >

					<div class="m-box" class="type-plus">

						

						<div class="anatomy-twin-radios anatomy-twin-radios--is_tripple"
							(dblclick)="clear('mobility')">

							<label class="not-observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="mobility" [value]="0"><i
									class="customInput-display"></i>

								<span>
									0
								</span>

							</label>

							<label class="observe">
                                
								<input type="radio" class="custom-check customInput" 
                                formControlName="mobility" [value]="1"><i
									class="customInput-display"></i>

								<span>
									1
								</span>

							</label>

							<label class="observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="mobility" [value]="2"><i
									class="customInput-display"></i>
								<span>
									2
								</span>

							</label>

						</div>

						
                    </div>
                    </div>
                    <div class="w30">
                     <p> אי יכולת להזיז עצמאית או על פי פקודה של הגפיים = {{0}}</p>
                     <p>  יכולת עצמאית או על פי פקודה להזיז 2 גפיים = {{1}}</p>
                     <p>  יכולת עצמאית או על פי פקודה להזיז 4 גפיים = {{2}}</p>
                    </div>

                    <div class="h100 w30 l-flex-w summary">
                        <section class="m-box" style="height: 100%;width: 100%;">
                            <h2 style="margin-right: 10em;">Comments</h2>
                            <textarea class="fulltext minH8" formControlName="mobilityNote"></textarea>
                            <button class="t-btn-edit" *ngIf="!gfs.isClosed"
                            (click)="atS.showAuto(gfs.Form?.get('mobilityNote'),'mobilityNote',1456)">Auto Text</button>
                        </section>
                    </div>
                    <p>{{gfs.Form.get('mobility').value}}</p>
                </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;;">-
        <h2>נשימה</h2>
        <div style="z-index: 7;">
            <div  style="display: flex;z-index: 1000; justify-content: space-between">
                <div style="direction: ltr" class="w20 anatomy-item" >

					<div class="m-box" class="type-plus">

						

						<div class="anatomy-twin-radios anatomy-twin-radios--is_tripple"
							(dblclick)="clear('breathing')">

							<label class="not-observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="breathing" [value]="0"><i
									class="customInput-display"></i>

								<span>
									0
								</span>

							</label>

							<label class="observe">
                                
								<input type="radio" class="custom-check customInput" 
                                formControlName="breathing" [value]="1"><i
									class="customInput-display"></i>

								<span>
									1
								</span>

							</label>

							<label class="observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="breathing" [value]="2"><i
									class="customInput-display"></i>
								<span>
									2
								</span>

							</label>

						</div>

						
                    </div>
                    </div>
                    <div class="w30">
                     <p> אפנאה= {{0}}</p>
                     <p> דיספנאה, נשימה שטוחה או מוגבלת= {{1}}</p>
                     <p>   יכולת נשימה עמוקה ושיעול חופשי = {{2}}</p>
                    </div>

                    <div class="h100 w30 l-flex-w summary">
                        <section class="m-box" style="height: 100%;width: 100%;">
                            <h2 style="margin-right: 10em;">Comments</h2>
                            <textarea class="fulltext minH8" formControlName="breathingNote"></textarea>
                            <button class="t-btn-edit" *ngIf="!gfs.isClosed"
                            (click)="atS.showAuto(gfs.Form?.get('breathingNote'),'breathingNote',1457)">Auto Text</button>
                        </section>
                    </div>
                    <p>{{gfs.Form.get('breathing').value}}</p>
                </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;;">-
        <h2>המודינמיקה</h2>
        <div style="z-index: 7;">
            <div  style="display: flex;z-index: 1000; justify-content: space-between">
                <div style="direction: ltr" class="w20 anatomy-item" >

					<div class="m-box" class="type-plus">

						

						<div class="anatomy-twin-radios anatomy-twin-radios--is_tripple"
							(dblclick)="clear('Hemodynamics')">

							<label class="not-observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="Hemodynamics" [value]="0"><i
									class="customInput-display"></i>

								<span>
									0
								</span>

							</label>

							<label class="observe">
                                
								<input type="radio" class="custom-check customInput" 
                                formControlName="Hemodynamics" [value]="1"><i
									class="customInput-display"></i>

								<span>
									1
								</span>

							</label>

							<label class="observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="Hemodynamics" [value]="2"><i
									class="customInput-display"></i>
								<span>
									2
								</span>

							</label>

						</div>

						
                    </div>
                    </div>
                    <div class="w30">
                     <p>  מערכים לפני הרדמה {{'MMHG'}}  ל.ד גבוה מ 50 = {{0}}</p>
                     <p> מערכים לפני הרדמה {{'MMHG'}}  ל.ד בטווח 20-50 = {{1}}</p>
                     <p> מערכים לפני הרדמה {{'MMHG'}}  ל.ד עד 20 = {{2}}</p>
                    </div>

                    <div class="h100 w30 l-flex-w summary">
                        <section class="m-box" style="height: 100%;width: 100%;">
                            <h2 style="margin-right: 10em;">Comments</h2>
                            <textarea class="fulltext minH8" formControlName="HemodynamicsNote"></textarea>
                            <button class="t-btn-edit" *ngIf="!gfs.isClosed"
                            (click)="atS.showAuto(gfs.Form?.get('HemodynamicsNote'),'HemodynamicsNote',1458)">Auto Text</button>
                        </section>
                    </div>
                    <p>{{gfs.Form.get('Hemodynamics').value}}</p>
                </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;;">-
        <h2>מצב הכרתי</h2>
        <div style="z-index: 7;">
            <div  style="display: flex;z-index: 1000; justify-content: space-between">
                <div style="direction: ltr" class="w20 anatomy-item" >

					<div class="m-box" class="type-plus">

						

						<div class="anatomy-twin-radios anatomy-twin-radios--is_tripple"
							(dblclick)="clear('recognition')">

							<label class="not-observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="recognition" [value]="0"><i
									class="customInput-display"></i>

								<span>
									0
								</span>

							</label>

							<label class="observe">
                                
								<input type="radio" class="custom-check customInput" 
                                formControlName="recognition" [value]="1"><i
									class="customInput-display"></i>

								<span>
									1
								</span>

							</label>

							<label class="observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="recognition" [value]="2"><i
									class="customInput-display"></i>
								<span>
									2
								</span>

							</label>

						</div>

						
                    </div>
                    </div>
                    <div class="w30">
                     <p>  אינו מגיב= {{0}}</p>
                     <p>  ניתן להעיר בריאה= {{1}}</p>
                     <p>  הכרה מלאה = {{2}}</p>
                    </div>

                    <div class="h100 w30 l-flex-w summary">
                        <section class="m-box" style="height: 100%;width: 100%;">
                            <h2 style="margin-right: 10em;">Comments</h2>
                            <textarea class="fulltext minH8" formControlName="recognitionNote"></textarea>
                            <button class="t-btn-edit" *ngIf="!gfs.isClosed"
                            (click)="atS.showAuto(gfs.Form?.get('recognitionNote'),'recognitionNote',1459)">Auto Text</button>
                        </section>
                    </div>
                    <p>{{gfs.Form.get('recognition').value}}</p>
                </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;;">-
        <h2>גוון עור</h2>
        <div style="z-index: 7;">
            <div  style="display: flex;z-index: 1000; justify-content: space-between">
                <div style="direction: ltr" class="w20 anatomy-item" >

					<div class="m-box" class="type-plus">

						

						<div class="anatomy-twin-radios anatomy-twin-radios--is_tripple"
							(dblclick)="clear('skinTone')">

							<label class="not-observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="skinTone" [value]="0"><i
									class="customInput-display"></i>

								<span>
									0
								</span>

							</label>

							<label class="observe">
                                
								<input type="radio" class="custom-check customInput" 
                                formControlName="skinTone" [value]="1"><i
									class="customInput-display"></i>

								<span>
									1
								</span>

							</label>

							<label class="observe">

								<input type="radio" class="custom-check customInput" 
                                formControlName="skinTone" [value]="2"><i
									class="customInput-display"></i>
								<span>
									2
								</span>

							</label>

						</div>

						
                    </div>
                    </div>
                    <div class="w30">
                     <p>  ציאנוטי (כחלון) = {{0}}</p>
                     <p> חיוור= {{1}}</p>
                     <p>תקין = {{2}}</p>
                    </div>

                    <div class="h100 w30 l-flex-w summary">
                        <section class="m-box" style="height: 100%;width: 100%;">
                            <h2 style="margin-right: 10em;">Comments</h2>
                            <textarea class="fulltext minH8" formControlName="skinToneNote"></textarea>
                            <button class="t-btn-edit" *ngIf="!gfs.isClosed"
                            (click)="atS.showAuto(gfs.Form?.get('skinToneNote'),'skinToneNote',1460)">Auto Text</button>
                        </section>
                    </div>
                    <p>{{gfs.Form.get('skinTone').value}}</p>
                </div>
        </div>
    </div>
    
    <div style="display: flex;justify-content: space-between;">
        <button class="accept" (click)="close(true)">Save and Close</button>
        <p> Total score</p>
        <p> {{totalScore()}}</p>
        <p>סה"כ ניקוד </p>
        
        <div style="display: grid;place-self: center;justify-items: end;">
            <span> חתימת האח/ות</span>
            <canvas id="canvasDoc" #canvasSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="200" height="100"   (click)="setCanvas()"></canvas>
            <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearSign()">                                            
                <ng-container>
                    <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                </ng-container>
            </button>
    
        </div>
    </div>
  
</div>
<app-autotext *ngIf="atS.Display"></app-autotext>